
    const data = {"name":"src/core/icons/radiobox-marked","data":{"viewBox":"0 0 24 24","data":"<path pid=\"0\" d=\"M12 20a8 8 0 0 1-8-8 8 8 0 0 1 8-8 8 8 0 0 1 8 8 8 8 0 0 1-8 8m0-18A10 10 0 0 0 2 12a10 10 0 0 0 10 10 10 10 0 0 0 10-10A10 10 0 0 0 12 2m0 5a5 5 0 0 0-5 5 5 5 0 0 0 5 5 5 5 0 0 0 5-5 5 5 0 0 0-5-5Z\"/>","originalColors":[],"stopColors":[]}}

            export default data
            